/* eslint-disable react/no-unknown-property, @typescript-eslint/ban-ts-comment */
import * as React from 'react';
import * as Styled from './SurveySparrow.styles';
import useSurveySparrowHeight from './useSurveySparrowHeight';
import useSurveySparrowMessage from './useSurveySparrowMessage';
import { useConfig } from '@ids/appshell';
import { useQuestionnairePageContext } from '@ids/context/QuestionnairePage';

const WWSS_ACCOUNT = 'westwingstudio.surveysparrow.com';
const WWSS_SURVEY_NAME = 'dein-eigenes-projekt';

const normalizeLanguage = (countryCode: string) => {
    const language = countryCode.toLowerCase();

    if (/ch/i.test(language) || !language) {
        return 'de';
    }
    return language.slice(0, 2);
};

const SurveySparrow = () => {
    const config = useConfig();
    const questionnairePageData = useQuestionnairePageContext();
    const wrapperRef = React.useRef<HTMLElement>(null);
    const iframeRef = React.useRef<HTMLIFrameElement>(null);
    const surveySparrowHeight = useSurveySparrowHeight(wrapperRef.current);
    const { isFormLoading } = useSurveySparrowMessage(iframeRef.current);
    const normalizedLanguage = normalizeLanguage(config.countryCode);

    return (
        <Styled.Wrapper
            ref={wrapperRef}
            $isLoading={isFormLoading}
            $height={surveySparrowHeight}
            data-testid="survey-sparrow-form"
        >
            {isFormLoading ? (
                <Styled.SkeletonContainer data-language={normalizedLanguage}>
                    <Styled.SkeletonMcqOption />
                    <Styled.SkeletonMcqOption />
                    <Styled.SkeletonMcqOption />
                    <Styled.SkeletonMcqOption />
                    <Styled.SkeletonMcqOption />
                    <Styled.SkeletonMcqOption />
                    <Styled.SkeletonMcqOption />
                    <Styled.SkeletonMcqOption />
                    <Styled.SkeletonButton />
                </Styled.SkeletonContainer>
            ) : null}
            {questionnairePageData?.sparrowFormToken && (
                <iframe
                    ref={iframeRef}
                    frameBorder={0}
                    allowFullScreen
                    // @ts-ignore
                    allowusermedia=""
                    title="Westwing Studio Questionnaire"
                    allow="camera *; microphone *"
                    src={`//${WWSS_ACCOUNT}/s/${WWSS_SURVEY_NAME}/${questionnairePageData.sparrowFormToken}?sparrowLang=${normalizedLanguage}`}
                />
            )}
        </Styled.Wrapper>
    );
};

export default SurveySparrow;
